<template>
  <div class="selectProvinceBox">
    <!-- 当前位置 -->
    <div class="currentPosition">
      <span class="current">
        <i class="iconfont icon-dingwei-icon"></i>
        <i class="thePlace">{{ address }}</i>
      </span>
      <span class="detail">
        当前位置
      </span>
    </div>
    <!-- 注册地 -->
    <!-- <div class="registerPosition">
      <p class="title">全国</p>
      <p class="city enableclick" data-set="999999">全国</p>
    </div> -->
    <!-- 切换城市 -->
    <div class="changeCity">
      <div v-for="(item, key, index) in regionMap" :key="index">
        <div class="title">{{ key }}</div>
        <div class="shell clearfix">
          <div
            v-for="(obj, key2, index) in item"
            :key="index"
            :data-set="obj"
            class="city fl enableclick"
            @click="cityClick(obj, key2)"
          >
            {{ key2 }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { regionMap, addressIphone } from '@/utils/index';

export default {
  name: 'selectProvince',
  data() {
    return {
      regionMap,
      address: '',
      adcode: '',
    };
  },
  mounted() {
    // 判断ios缓存问题
    addressIphone();
    this.address = this.$route.query.address;
    this.adcode = this.$route.query.adcode;
  },
  methods: {
    cityClick(adcode, name) {
      this.address = name;
      this.adcode = adcode;
      this.$router.push({
        path: '/supermarket/v2/',
        query: { address: name, adcode },
      });
    },
  },
};
</script>
<style scoped>
.city {
  width: 104px;
  height: 40px;
  background-color: #fff;
  font-size: 14px;
  color: #333333;
  letter-spacing: 0.48px;
  text-align: center;
  line-height: 40px;
  margin-left: 16px;
  margin-bottom: 10px;
  box-sizing: border-box;
}
.shell {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}
.clearfix:after {
  content: '020';
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}

.clearfix {
  /* 触发 hasLayout */
  zoom: 1;
}
.fl {
  float: left;
}
/* 注册地址 */
.registerPosition {
  width: 100%;
}
/* 当前位置 */
.currentPosition {
  width: 100%;
  height: 50px;
  background-color: #fff;
  line-height: 50px;
  padding-left: 16px;
  padding-right: 16px;
  box-sizing: border-box;
}
.currentPosition .current {
  font-size: 17px;
  color: #d81e06;
  position: absolute;
  left: 16px;
}
.currentPosition .detail {
  font-size: 14px;
  color: #999999;
  float: right;
}
.title {
  margin-left: 16px;
  font-size: 13px;
  color: #999999;
  letter-spacing: 0.54px;
  line-height: 35px;
  height: 35px;
  text-align: left;
}
/* 地区被选中的状态 */
.selected {
  border: 1px solid #f65846;
  color: #f65846;
}
</style>
